function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

window.onload = function (event) {
  const tabs = {
    debug: true,
    progress: 0,
    prevTab: "",
    tabActive: "tab-0",
    valor: "",
    categoryActive: "Rings",
    ideaActive: "Have an idea",
    metalActive: "-",
    surfaceActive: "-",
    shapeActive: "-",
    templateActive: "-",
    byPass: "",
    menuJamp: "",
    menuJamp2: "",

    goBack: function () {
      this.showTab(this.prevTab);
    },

    constrolleSections: function (tab, action, valor, menu = 1, validator = false) {

      if (validator) {      
        switch(validator){
          case "idea_tell_us_detail":
            if(!this.validateIdeaTellUsDetail()) return;
            break;
          case "tell_us_idea":
            if(!this.validateIdeaTellUsIdea()) return;
            break;
        }
      }

      this.prevTab = this.tabActive + this.valor;
      this.valor = valor;
      this.tabActive = tab;
      this.showMenu(menu);

      if (this.debug) {
        console.log(
          "CONTROLLER=",
          tab,
          action,
          valor,
          menu,
          "prevTab: ",
          this.prevTab
          ,"validator: ",
          validator
        );
      }


      switch (tab) {
        case "tab-0":
          break;

        case "tab-1":
          this.showTab("1", "");
          break;

        case "tab-2":
          if (
            this.categoryActive === "Cufflinks" ||
            this.categoryActive === "Pendants"
          ) {
            this.showTab("3a", "");
            document
              .getElementsByClassName("bt-next-3a")[0]
              .classList.add("show"); // Mostrar el botón "Next" de "Tell us what you have in mind"
            this.showMenu("2");
          } else if (this.categoryActive === "Rings") {
            this.showTab("2", ""); // Continuar con la opción de Rings            
          }
          break;

        case "tab-3":
          if (
            this.categoryActive === "Cufflinks" ||
            this.categoryActive === "Pendants"
          ) {
            this.showTab("3b", ""); // Ir a "Metals"
            document
              .getElementsByClassName("cbt-back-2")[0]
              .classList.remove("show");
            document
              .getElementsByClassName("cbt-back-3b")[0]
              .classList.add("show");
          } else {
            if (valor !== "") {
              this.showTab("3", valor); // Continuar con los Metales o tell us
              document
                .getElementsByClassName("cbt-back-3b")[0]
                .classList.remove("show");
              document
                .getElementsByClassName("cbt-back-2")[0]
                .classList.add("show");
            }
          }
          break;

        case "tab-3a":
          if (
            this.categoryActive === "Rings" &&
            this.ideaActive === "Have an idea"
          ) {
            document
              .getElementsByClassName("bt-next-3a")[0]
              .classList.add("show"); // Habilitar el botón "Next" para seguir adelante
          } else if (
            this.categoryActive === "Cufflinks" ||
            this.categoryActive === "Pendants"
          ) {
            document
              .getElementsByClassName("bt-next-3c")[0]
              .classList.add("show"); // Ir a la sección de "Crest"
          }
          this.showTab("3a", ""); // Mostrar "Tell us what you have in mind"
          break;

        case "tab-3b":
          this.showTab("3b", "");
          break;

        case "tab-3c":
          this.showTab("3c", ""); // Ir al de crest
          this.showMenu("3");
          document
            .getElementsByClassName("bt-next-3c")[0]
            .classList.add("show");            

          if(this.prevTab === "tab-2" && (this.categoryActive === "Pendants" || this.categoryActive === "Cufflinks")){
            document
            .getElementsByClassName("cbt-back-5e")[0]
            .classList.remove("show");
            document
            .getElementsByClassName("bt-back-5e")[0]
            .classList.remove("show");
            document
              .getElementsByClassName("cbt-back-3a")[0]
              .classList.add("show");
            document
              .getElementsByClassName("bt-back-3a")[0]
              .classList.add("show");
          }

          if (this.prevTab === "tab-3a") {
            document
            .getElementsByClassName("cbt-back-5e")[0]
            .classList.remove("show");
            document
            .getElementsByClassName("bt-back-5e")[0]
            .classList.remove("show");
            document
              .getElementsByClassName("cbt-back-3a")[0]
              .classList.add("show");
            document
              .getElementsByClassName("bt-back-3a")[0]
              .classList.add("show");
          }

          if (this.prevTab === "tab-5e") {
            document
              .getElementsByClassName("cbt-back-3a")[0]
              .classList.remove("show");
            document
              .getElementsByClassName("bt-back-3a")[0]
              .classList.remove("show");
            document
              .getElementsByClassName("cbt-back-5e")[0]
              .classList.add("show");
              document
              .getElementsByClassName("bt-back-5e")[0]
              .classList.add("show"); 
          }

          break;

        case "tab-4":
          this.showTab("4", ""); // Paso final
          break;

        case "tab-5":
          this.showTab("5", valor, "2"); // Manejo de Tab 5 con variantes
          break;
      }
    },

    validateIdeaTellUsDetail: function () {
      const text = document.getElementById("idea_tell_us_detail").value;

      if (text.length === 0) {
        document.getElementById("idea_tell_us_detail_error").style.display = 'block';
        const formContainer = document.querySelector('.custom_consultation_form');
        formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return false;
      } else {
        document.getElementById("idea_tell_us_detail_error").style.display = 'none';
        return true;
      }
    },

    validateIdeaTellUsIdea: function () {
      const text = document.getElementById("tell_us_idea").value;

      if (text.length === 0) {
        document.getElementById("tell_us_idea_error").style.display = 'block';
        const formContainer = document.querySelector('.custom_consultation_form');
        formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return false;
      } else {
        document.getElementById("tell_us_idea_error").style.display = 'none';
        return true;
      }
    },

    showTab: function (number, variant, force = "-") {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");

      // Ocultar todas las pestañas (tabs)
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      // Determina qué sección mostrar (se maneja con el número y variante)
      var apply = number != "" && variant != "" ? number + variant : number;
      document.getElementById("tab-" + apply).style.display = "block"; // Muestra la sección correspondiente
      
      // Scroll to the top of the form container smoothly
      const formContainer = document.querySelector('.custom_consultation_form');
      if (formContainer) {
        setTimeout(() => {
          formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }

      // Logica para determinar la ruta cuando selecciona una idea
      if(this.prevTab == 'tab-2'){
        if (this.categoryActive === "Rings") {
          if (this.ideaActive === "Have an idea") {
            // Si está en "Have an idea?", va a "Tell us what you have in mind"
            if (number != "3a") this.showTab("3a", ""); // Tell us what you have in mind
            document
              .getElementsByClassName("bt-next-3a")[0]
              .classList.add("show"); // Muestra el botón de "Next"
          } else if (this.ideaActive === "See Options") {
            // Si está en "See Options", sigue el camino de "Surface" -> "Shape" -> "Template"
            if (number != "5b") this.showTab("5b", ""); // Surface
            document
              .getElementsByClassName("bt-next-5b")[0]
              .classList.add("show"); // Muestra el botón de "Next"
          }
        }
      }

      // Rutas para Cufflinks y Pendants
      else if (
        this.categoryActive === "Cufflinks" ||
        this.categoryActive === "Pendants"
      ) {
        document.getElementsByClassName("bt-next-3a")[0].classList.add("show"); // Muestra el botón de "Next"
      }

      // Lógica para navegar entre las pestañas
      if (this.menuJamp != "" && this.menuJamp == "tab-2") {
        document
          .getElementsByClassName("cbt-back-empty3")[0]
          .classList.remove("show");
        document.getElementsByClassName("cbt-back-t1")[0].classList.add("show"); // Mostrar el botón de "Atrás" hacia la sección de "Productos"
        document
          .getElementsByClassName("cbt-back-t3c")[0]
          .classList.remove("show");

        document.getElementsByClassName("bt-back-t1")[0].classList.add("show");
        document
          .getElementsByClassName("bt-back-t3c")[0]
          .classList.remove("show");
      } else if (this.menuJamp != "" && this.menuJamp == "tab-3c") {
        document
          .getElementsByClassName("cbt-back-empty3")[0]
          .classList.remove("show");
        document
          .getElementsByClassName("cbt-back-t1")[0]
          .classList.remove("show");
        document
          .getElementsByClassName("cbt-back-t3c")[0]
          .classList.add("show");

        document
          .getElementsByClassName("bt-back-t1")[0]
          .classList.remove("show");
        document.getElementsByClassName("bt-back-t3c")[0].classList.add("show");
      }

      if (this.menuJamp2 != "" && this.menuJamp2 == "tab-5e") {
        document
          .getElementsByClassName("cbt-back-empty2")[0]
          .classList.remove("show");
        document.getElementsByClassName("cbt-back-5e")[0].classList.add("show");
        document
          .getElementsByClassName("cbt-back-3b")[0]
          .classList.remove("show");

        document.getElementsByClassName("bt-back-5e")[0].classList.add("show");
        document
          .getElementsByClassName("bt-back-3b")[0]
          .classList.remove("show");
      } else if (this.menuJamp2 != "" && this.menuJamp2 == "tab-3b") {
        document
          .getElementsByClassName("cbt-back-empty2")[0]
          .classList.remove("show");
        document
          .getElementsByClassName("cbt-back-5e")[0]
          .classList.remove("show");

        document.getElementsByClassName("cbt-back-3b")[0].classList.add("show");

        document
          .getElementsByClassName("bt-back-5e")[0]
          .classList.remove("show");
        document.getElementsByClassName("bt-back-3b")[0].classList.add("show");
      }
    },

    showMenu: function (number, force = "-") {
      if (this.debug) {
        console.log("SHOWMENU= TAB:" + number);
      }

      if (this.byPass != "") {
        number = this.byPass;
      }

      tablinks = document.getElementsByClassName("text_circle");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" done", "");
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      for (i = 0; i < tablinks.length; i++) {
        if (i + 1 <= number) {
          tablinks[i].className = tablinks[i].className.replace(
            "text_circle",
            "text_circle done"
          );
        }
      }

      if (force != "-") {
        number = force;
      }

      document.getElementById("tab-0" + number).classList.add("active");
      document.getElementById("tab-0" + number).classList.add("done");

      if (this.byPass != "") {
        this.byPass = "";
      }
    },

    setProductCategory: function (option, number) {
      const element = document.getElementById("cat-" + number);
      const input = document.getElementById("product_category");

      if (element.classList.contains("active")) {
        element.classList.remove("active");
        this.categoryActive = "Rings";
        input.value = "";
        document
          .getElementsByClassName("bt-next-1")[0]
          .classList.remove("show");
      } else {
        const optionCategories = document.getElementsByClassName("col-image");
        for (let i = 0; i < optionCategories.length; i++) {
          optionCategories[i].classList.remove("active");
        }
        element.classList.add("active");
        this.categoryActive = option;
        input.value = option;

        document.getElementsByClassName("bt-next-1")[0].classList.add("show");
        // ----------------------------
        // FILTER METALS BY CATEGORY
        // ----------------------------
        const selectedCategory = option;
        const allMetals = document.querySelectorAll(".a-metal");

        allMetals.forEach((metal) => {
          const metalFor = metal.dataset.metalFor;

          if (metalFor === "All" || metalFor === selectedCategory) {
            metal.style.display = "flex";
          } else {
            metal.style.display = "none";
          }
        });
      }
    },

    setIdea: function (option, number) {
      optionCategoies = document.getElementsByClassName("a-idea");
      for (i = 0; i < optionCategoies.length; i++) {
        optionCategoies[i].className = optionCategoies[i].className.replace(
          " active",
          ""
        );
      }

      this.ideaActive = option;
      document.getElementById("product_idea").value = option;
      document.getElementById("idea-" + number).classList.add("active");
      document
        .getElementsByClassName("cbt-next-empty")[0]
        .classList.remove("show");

      if (number == "1") {
        document.getElementsByClassName("cbt-next-2")[0].classList.add("show");
        document
          .getElementsByClassName("cbt-next-55")[0]
          .classList.remove("show");
        document.getElementsByClassName("bt-next-2")[0].classList.add("show");
        document
          .getElementsByClassName("bt-next-55")[0]
          .classList.remove("show");
      } else if (number == "2") {
        document
          .getElementsByClassName("cbt-next-2")[0]
          .classList.remove("show");
        document.getElementsByClassName("cbt-next-55")[0].classList.add("show");
        document
          .getElementsByClassName("bt-next-2")[0]
          .classList.remove("show");
        document.getElementsByClassName("bt-next-55")[0].classList.add("show");
      }
    },

    setMetal: function (option, number) {
      const element = document.getElementById("metal-" + number);
      const input = document.getElementById("product_metal");

      if (element.classList.contains("active")) {
        // Deselect the option
        element.classList.remove("active");
        this.metalActive = "";
        input.value = "";
        document
          .getElementsByClassName("bt-next-3b")[0]
          .classList.remove("show");
      } else {
        // Select the option
        const optionMetals = document.getElementsByClassName("a-metal");
        for (let i = 0; i < optionMetals.length; i++) {
          optionMetals[i].classList.remove("active");
        }
        element.classList.add("active");
        this.metalActive = option;
        input.value = option;
        const btn = document.querySelector('.bt-next-3b');
        if (btn) {
          btn.classList.add('show');
          btn.click();
        }
      }
    },

    setHeaderTab: function (number) {
      if (this.debug) {
        console.log("setHeaderTab:" + number);
      }
      var i, tabcontent;
      tabscontent = document.getElementsByClassName("tabscontent");
      for (i = 0; i < tabscontent.length; i++) {
        tabscontent[i].style.display = "none";
        tabscontent[i].className = tabscontent[i].className.replace(
          " active",
          ""
        );
      }

      if (number == "1") {
        document.getElementById("crest-1").classList.add("active");
        document.getElementById("crest-2").classList.remove("active");
      } else if (number == "2") {
        document.getElementById("crest-2").classList.add("active");
        document.getElementById("crest-1").classList.remove("active");
      }

      document.getElementsByClassName("bt-next-3c")[0].classList.add("show");
      document.getElementById("tabs-" + number).classList.add("active");
    },

    setSurface: function (option, number) {
      optionSurface = document.getElementsByClassName("a-surface");
      for (i = 0; i < optionSurface.length; i++) {
        optionSurface[i].className = optionSurface[i].className.replace(
          " active",
          ""
        );
      }
      this.surfaceActive = option;
      document.getElementById("product_surface").value = option;
      document.getElementById("surface-" + number).classList.add("active");
      document.getElementsByClassName("bt-next-5c")[0].classList.add("show");
    },

    setShape: function (option, number) {
      const element = document.getElementById("shape-" + number);
      const input = document.getElementById("product_shape");

      if (element.classList.contains("active")) {
        // Deselect the option
        element.classList.remove("active");
        this.shapeActive = "";
        input.value = "";
        document
          .getElementsByClassName("bt-next-5d")[0]
          .classList.remove("show");
      } else {
        // Select the option
        const allShapes = document.getElementsByClassName("a-shape");
        for (let i = 0; i < allShapes.length; i++) {
          allShapes[i].classList.remove("active");
        }
        element.classList.add("active");
        this.shapeActive = option;
        input.value = option;
        document.getElementsByClassName("bt-next-5d")[0].classList.add("show");
      }
    },
    setTemplate: function (option, number) {
      const element = document.getElementById("template-" + number);
      const input = document.getElementById("product_template");

      if (element.classList.contains("active")) {
        // Deselect the option
        element.classList.remove("active");
        this.templateActive = "";
        input.value = "";
        document
          .getElementsByClassName("bt-next-5e")[0]
          .classList.remove("show");
      } else {
        // Select the option
        const allTemplates = document.getElementsByClassName("a-template");
        for (let i = 0; i < allTemplates.length; i++) {
          allTemplates[i].classList.remove("active");
        }
        element.classList.add("active");
        this.templateActive = option;
        input.value = option;
        document.getElementsByClassName("bt-next-5e")[0].classList.add("show");
      }
    },

    setBandStyle: function (option, number) {
      const element = document.getElementById("bandstyle-" + number);
      const input = document.getElementById("product_band_style");

      if (element.classList.contains("active")) {
        // Deselect the option
        element.classList.remove("active");
        this.bandstyleActive = "";
        input.value = "";
        document
          .getElementsByClassName("bt-next-to-3c")[0]
          .classList.remove("show");
      } else {
        // Select the option
        const allBandStyles = document.getElementsByClassName("a-bandstyle");
        for (let i = 0; i < allBandStyles.length; i++) {
          allBandStyles[i].classList.remove("active");
        }
        element.classList.add("active");
        this.bandstyleActive = option;
        input.value = option;
        document
          .getElementsByClassName("bt-next-to-3c")[0]
          .classList.add("show");
      }
    },

    checkTextarea: function () {
      txts = document.getElementsByClassName("idea_tell_us_detail");
      if (/^[0-9]+$/.test(txts[0].getAttribute("minlength"))) {
        funcParseInt = function () {
          len = parseInt(this.getAttribute("minlength"), 10);
          if (this.value.length > len) {
            document
              .getElementsByClassName("bt-next-3a")[0]
              .classList.add("show");
          } else {
            document
              .getElementsByClassName("bt-next-3a")[0]
              .classList.remove("show");
          }
        };
        txts[0].onkeyup = funcParseInt;
        txts[0].onblur = funcParseInt;
      }
    },
    deselectOption: function (elementId, inputId) {
      const element = document.getElementById(elementId);
      const input = document.getElementById(inputId);

      if (element.classList.contains("active")) {
        // Remove active state
        element.classList.remove("active");

        // Clear the corresponding hidden input field
        if (input) input.value = "";
      }
    },
  };

  var userSelection = document.getElementsByClassName("aButton");
  for (let i = 0; i < userSelection.length; i++) {
    userSelection[i].addEventListener("click", function () {
      if (
        userSelection[i].classList &&
        userSelection[i].classList.contains("bt--back")
      ) {
        tabs.ideaActive = "Have an idea";
      }
      tabs.constrolleSections(
        this.getAttribute("data-tab"),
        this.getAttribute("data-action"),
        this.getAttribute("data-valor"),
        this.getAttribute("data-menu"),
        this.getAttribute("data-validator")
      );
    });
  }

  tabs.constrolleSections("tab-3b", "", "", 1);

  // Categories
  document.getElementById("cat-1").addEventListener("click", function (e) {
    tabs.setProductCategory("Rings", "1");
  });
  document.getElementById("cat-2").addEventListener("click", function (e) {
    tabs.setProductCategory("Pendants", "2");
  });
  document.getElementById("cat-3").addEventListener("click", function (e) {
    tabs.setProductCategory("Cufflinks", "3");
  });

  // Idea
  document.getElementById("idea-1").addEventListener("click", function (e) {
    tabs.setIdea("Have an idea", "1");
  });
  document.getElementById("idea-2").addEventListener("click", function (e) {
    tabs.setIdea("See Options", "2");
  });


  // Crest
  document.getElementById("crest-1").addEventListener("click", function (e) {
    tabs.setHeaderTab("1");
  });
  document.getElementById("crest-2").addEventListener("click", function (e) {
    tabs.setHeaderTab("2");
  });

  // Surface
  document.getElementById("surface-1").addEventListener("click", function (e) {
    tabs.toggleOption("surface-1", "product_surface", "a-surface");
  });
  document.getElementById("surface-2").addEventListener("click", function (e) {
    tabs.toggleOption("surface-2", "product_surface", "a-surface");
  });
  // Ensure "Next" button is visible
  document.getElementsByClassName("bt-next-5c")[0].classList.add("show");

  // Shape
  /*document.getElementById("shape-1").addEventListener("click", function (e) {
    tabs.toggleOption("shape-1", "product_shape", "a-shape");
  });
  document.getElementById("shape-2").addEventListener("click", function (e) {
    tabs.toggleOption("shape-2", "product_shape", "a-shape");
  });
  // Ensure "Next" button is visible
  document.getElementsByClassName("bt-next-5d")[0].classList.add("show");*/

  // Template
  document.getElementById("template-1").addEventListener("click", function (e) {
    tabs.toggleOption("template-1", "product_template", "a-template");
  });
  document.getElementById("template-2").addEventListener("click", function (e) {
    tabs.toggleOption("template-2", "product_template", "a-template");
  });
  document.getElementById("template-3").addEventListener("click", function (e) {
    tabs.toggleOption("template-3", "product_template", "a-template");
  });
  document.getElementById("template-4").addEventListener("click", function (e) {
    tabs.toggleOption("template-4", "product_template", "a-template");
  });
  document.getElementById("template-5").addEventListener("click", function (e) {
    tabs.toggleOption("template-5", "product_template", "a-template");
  });
  document.getElementById("template-6").addEventListener("click", function (e) {
    tabs.toggleOption("template-6", "product_template", "a-template");
  });
  document.getElementById("template-7").addEventListener("click", function (e) {
    tabs.toggleOption("template-7", "product_template", "a-template");
  });
  document.getElementById("template-8").addEventListener("click", function (e) {
    tabs.toggleOption("template-8", "product_template", "a-template");
  });
  // Ensure "Next" button is visible
  document.getElementsByClassName("bt-next-5e")[0].classList.add("show");

  // Band Style
  /*
  document
    .getElementById("bandstyle-1")
    .addEventListener("click", function (e) {
      tabs.toggleOption("bandstyle-1", "product_band_style", "a-bandstyle");
      document.querySelector('.band_style_file_wrapper').style.display = 'none';
    });
    
  document
    .getElementById("bandstyle-2")
    .addEventListener("click", function (e) {
      tabs.toggleOption("bandstyle-2", "product_band_style", "a-bandstyle");
      document.querySelector('.band_style_file_wrapper').style.display = 'none';
    });
    
  document
    .getElementById("bandstyle-3")
    .addEventListener("click", function (e) {
      tabs.toggleOption("bandstyle-3", "product_band_style", "a-bandstyle");
      document.querySelector('.band_style_file_wrapper').style.display = 'flex';
    });
  // Ensure "Next" button is visible
  document.getElementsByClassName("bt-next-to-3c")[0].classList.add("show");
  */

  // Add the toggleOption function
  tabs.toggleOption = function (elementId, inputId, elementFamilyClass) {
    const element = document.getElementById(elementId);
    const elementFamily = document.getElementsByClassName(elementFamilyClass);
    const input = document.getElementById(inputId);

    //remove all previous active elements from same class, except current element
    [...elementFamily].forEach((e) => {
      if (e.id !== elementId) {
        e.classList.remove("active");
      }
    });

    if (element.classList.contains("active")) {
      // Deselect the option
      element.classList.remove("active");

      // Clear the corresponding hidden input field
      if (input) input.value = "";
    } else {
      // Select the option
      element.classList.add("active");

      // Set the value of the hidden input field
      if (input) input.value = element.textContent.trim();
    }
  };

  // FORM ---------------------------------------------------------------------------------------------
  const forms = {
    debug: true,
    documentForm: document.consultationForm,
    url: document.getElementById("consultationForm").getAttribute("data-url"),
    sussesTitle: document
      .getElementById("consultationForm")
      .getAttribute("data-susses-title"),
    sussesDetail: document
      .getElementById("consultationForm")
      .getAttribute("data-susses-detail"),
    errorTitle: document
      .getElementById("consultationForm")
      .getAttribute("data-error-title"),
    errorDetail: document
      .getElementById("consultationForm")
      .getAttribute("data-error-title"),

    init: function () {
      if (this.debug) {
        console.log("init");
        console.log("form:", this.documentForm);
        console.log("url:", this.url);
      }
      if (this.validate(this.documentForm)) {
        const data = this.collection_data();
        this.send(data);
      }
    },
    validate: function (form) {
      if (this.debug) console.log("Validate:", form);
      let error = "";
      const ideaActive = tabs.ideaActive;

      // Required fields only
      error += this.valid_complete(form.contact_first_name, "* First Name");
      error += this.valid_complete(form.contact_email, "* Email");
      error += this.valid_complete(
        form.contact_shipping_country,
        "* Shipping Country"
      );
      error += this.valid_complete(form.product_metal, "* Metal");

      // Conditionally required field
      if (ideaActive === "Have an idea") {
        error += this.valid_complete(
          form.idea_tell_us_detail,
          "* Your Idea Field"
        );
      }

      if (this.debug) console.log(error);

      if (error !== "") {
        const title = "Missing information";
        this.showFinalError(title, error);
        return false;
      }
      this.hideFinalError();
      return true;
    },
    showFinalError: function (title, error) {
        document.getElementById("final-error").style.display = 'block';
        document.getElementById("final-error").innerHTML = `<p class="validation-error-message">${title}</br> ${error}</p>`;
    },
    hideFinalError: function () {
        document.getElementById("final-error").style.display = 'none';
    },
    send: function (data) {
      if (this.debug) console.log("!!!!!!!!!!! Send Form:", data);

      const formdata = new FormData();

      for (let i = 0; i < this.documentForm.elements.length; i++) {
        formdata.append(
          this.documentForm.elements[i].name,
          this.documentForm.elements[i].value
        );
      }

      // Handle multiple files for each uploader
      const uploadInputs = [
        'idea_tell_us_file',
        'idea_tell_us_file_1',
        'find_crest_name_file',
        //'band_style_file'
      ];
      
      uploadInputs.forEach(inputId => {
        const input = document.getElementById(inputId);
        if (input && input.files && input.files.length > 0) {
          Array.from(input.files).slice(0, 3).forEach((file, index) => {
            formdata.append(`${inputId}_${index}`, file);
          });
        }
      });

      // Log all form entries
      if(this.debug) {
        for (let entry of formdata.entries()) {
          console.log('Form entry:', entry[0], entry[1]);
          
          // If entry is a file, log file details
          if (entry[1] instanceof File) {
            console.log('File details:', {
              name: entry[1].name,
              size: entry[1].size,
              type: entry[1].type
            });
          }
        }
      }

      document.getElementById("submit-bottom").disabled = true;
      document.getElementById("submit-bottom").innerHTML = "Sending...";

      fetch(`${this.url}`, {
        method: "POST",
        body: formdata,
      })
        .then((response) => response.json())
        .then((response) => {
          if (this.debug) console.log(JSON.stringify(response));
          window.location.href = "/pages/consultation-form-thanks";
        })
        .catch((err) => {
          if (this.debug) console.log(JSON.stringify(err));
          document.getElementById("submit-bottom").disabled = false;
          document.getElementById("submit-bottom").innerHTML = "SEND";
          this.showFinalError('There was an error submitting your form', 'Please try again or contact us.');
        });
    },
    valid_complete: function (obj, name) {
      if (this.debug) console.log("valid_complete");
      if (obj && obj.value === "") {
        return `\n<strong>${name}</strong> is required.<br>`;
      }
      return "";
    },
    showMsn: function (title, errors) {
      if (this.debug) console.log("Show Error Message");
      document.getElementsByClassName("message")[0].classList.add("show");
      document.getElementsByClassName("message-title")[0].innerHTML = title;
      document.getElementsByClassName("message-main")[0].innerHTML = errors;
    },
    showModal: function (title, errors) {
      if (this.debug) console.log("Show Modal Message");
      window.location.href = "#faltan_datos";
      document.getElementById("faltan_datos_title").innerHTML = title;
      document.getElementById("faltan_datos_detail").innerHTML = errors;
    },
    collection_data: function () {
      const formdata = new FormData();
      for (let i = 0; i < this.documentForm.elements.length; i++) {
        formdata.append(
          this.documentForm.elements[i].name,
          this.documentForm.elements[i].value
        );
      }
      
      // Handle multiple files for each uploader
      const uploadInputs = [
        'idea_tell_us_file',
        'idea_tell_us_file_1',
        'find_crest_name_file',
        //'band_style_file'
      ];
      
      uploadInputs.forEach(inputId => {
        const input = document.getElementById(inputId);
        if (input && input.files && input.files.length > 0) {
          Array.from(input.files).slice(0, 3).forEach((file, index) => {
            formdata.append(`${inputId}_${index}`, file);
          });
        }
      });
      
      return formdata;
    },
  };

  // Add event listener for form submission
  document
    .getElementById("submit-bottom")
    .addEventListener("click", function (event) {
      if (event.target.classList.contains("submit-bottom")) {
        forms.init();
      }
    });

  // Add event listener to close the message
  document
    .getElementsByClassName("message-close")[0]
    .addEventListener("click", function (event) {
      document.getElementsByClassName("message")[0].classList.remove("show");
    });

  // Search crest ------------------------------------------------------------------------------------
  const searchCrest = {
    debug: true,
    documentCrestForm: document.formCrestFamily,
    url: document.getElementById("formCrestFamily").getAttribute("data-url"),
    errorTitle: document
      .getElementById("formCrestFamily")
      .getAttribute("data-error-title"),
    errorTitle: document
      .getElementById("formCrestFamily")
      .getAttribute("data-error-title"),

    init: function () {
      if (this.debug) {
        console.log("init");
      }
      if (this.debug) {
        console.log("form:", this.documentCrestForm);
      }
      if (this.debug) {
        console.log("url:", this.url);
      }
      if (this.validate(document.getElementById("term").value)) {
        this.send();
      }
    },
    validate: function (field) {
      if (this.debug) {
        console.log("Vlidate:", field);
      }
      error = "";
      // Form data to be validated
      error += this.valid_complete(field, "* Name");

      if (this.debug) {
        console.log(error);
      }

      if (error != "") {
        title = "Empty Data";
        this.showImage(error);
        return false;
      }
      return true;
    },
    send: function () {
      if (this.debug) {
        console.log("Searching crest...");
      }

      this.hideCrestError();

      document.getElementsByClassName("loading-crest-spinner")[0].style.display = 'flex';

      formdata = new FormData();
      formdata.append("term", document.getElementById("term").value);
      formdata.append("dataset[info]", "");
      formdata.append("dataset[crest]", "crest");
      formdata.append("dataset[image]", "");

      fetch(`${this.url}`, {
        method: "POST",
        body: formdata,
      })
        .then((response) => response.json())
        .then((response) => {
          // Susses Menssage
          if (this.debug) {
            console.log(JSON.stringify(response));
          }
          document.getElementsByClassName("loading-crest-spinner")[0].style.display = 'none';
          this.showImage(response);
        })
        .catch((err) => {
          // Error Menssage
          if (this.debug) {
            console.log(JSON.stringify(err));
          }
          document.getElementsByClassName("loading-crest-spinner")[0].style.display = 'none';
          this.showCrestError();
        });
    },
    valid_complete: function (obj, name, type) {
      if (this.debug) {
        console.log("valid_complete");
      }
      if (type === "int") {
        if (obj.value === "" || isNaN(obj.value)) {
          return `\n<strong>${name}</strong> is required.<br>`;
        } else {
          return "";
        }
      } else if (obj.value === "") {
        return `\n<strong>${name}</strong> is required.<br>`;
      } else {
        return "";
      }
    },
    valid_length: function (obj, name, leng) {
      if (this.debug) {
        console.log("valid_length");
      }
      if (obj.length >= leng) {
        return "";
      } else {
        return `\n<strong>${name}</strong> requires at least ${leng} letters.<br>`;
      }
    },
    showCrestError: function () {
      document.getElementsByClassName("search-error")[0].style.display = 'block';
    },
    hideCrestError: function () {
      document.getElementsByClassName("search-error")[0].style.display = 'none';
    },
    showMsn: function (title, errors) {
      if (this.debug) {
        console.log("Show Error Message");
      }
      document.getElementsByClassName("message")[0].classList.add("show");
      document.getElementsByClassName("message-title")[0].innerHTML = title;
      document.getElementsByClassName("message-main")[0].innerHTML = errors;
    },
    showImage: function (response) {
      if (this.debug) {
        console.log("Show Erro Message");
      }
      if (response[0] != undefined && response[0] != "") {
        image = response[0][0][1][0]["crest_url"];
        document
          .getElementsByClassName("search-result")[0]
          .classList.add("show");
        document.getElementsByClassName(
          "search-result"
        )[0].innerHTML = `<div class="cont-img"><img src="https://hjlibrary.gohapp.com/files/crests/${image}" alt="Image"></div>`;
        // Add dato to post
        document.getElementById(
          "file_crest"
        ).value = `https://hjlibrary.gohapp.com/files/crests/${image}`;
      } else {
        // document.getElementsByClassName('search-result')[0].classList.add("show");
        document.getElementsByClassName("search-result")[0].innerHTML =
          '<div class="cont-img">No se encotraron resultados</div>';
      }
    },
  };


// search creast on "term" field type
document.getElementById("term").addEventListener("keyup", 
  debounce(function(event) {
    searchCrest.init();
  }, 500)  // 300ms delay
);

  document
    .getElementsByClassName("search-button")[0]
    .addEventListener("click", function (event) {
      searchCrest.init();
    });

  // Add image preview and remove functionality
  function setupImageUpload(inputId) {
    const input = document.getElementById(inputId);
    const wrapper = input.parentElement;
    
    // Add multiple attribute to input
    input.setAttribute('multiple', 'multiple');
    
    // Add classes to the wrapper for easier targeting
    wrapper.classList.add('multi-upload-wrapper');
    
    // Create a container for image previews if it doesn't exist
    let previewContainer = wrapper.querySelector('.preview-container');
    if (!previewContainer) {
      previewContainer = document.createElement('div');
      previewContainer.className = 'preview-container';
      wrapper.appendChild(previewContainer);
    }
    
    // Create a separate container for the clear all button
    let clearAllContainer = wrapper.querySelector('.clear-all-container');
    if (!clearAllContainer) {
      clearAllContainer = document.createElement('div');
      clearAllContainer.className = 'clear-all-container';
      wrapper.appendChild(clearAllContainer);
    }
    
    // Find or create instruction elements
    let mainInstructionEl = wrapper.querySelector('.upload-main-instruction');
    let subInstructionEl = wrapper.querySelector('.upload-sub-instruction');
    
    // If instruction elements don't exist with proper classes, find them by position and add classes
    const pElements = wrapper.querySelectorAll('p');
    if (!mainInstructionEl && pElements.length > 0) {
      pElements[0].classList.add('upload-main-instruction');
      mainInstructionEl = pElements[0];
      mainInstructionEl.textContent = 'Tap to add images';
    }
    
    if (!subInstructionEl && pElements.length > 1) {
      pElements[1].classList.add('upload-sub-instruction');
      subInstructionEl = pElements[1];
      subInstructionEl.textContent = 'jpg/jpeg/png - 3 max';
    }
    
    // Handle file selection
    input.addEventListener('change', function(event) {
      const files = Array.from(this.files).slice(0, 3); // Limit to 3 files
      if (files.length === 0) return;
      
      // Clear existing previews
      previewContainer.innerHTML = '';
      clearAllContainer.innerHTML = '';
      
      // Hide all instruction elements
      wrapper.querySelectorAll('.upload-main-instruction, .upload-sub-instruction, .file-name, .file-icon').forEach(el => {
        el.style.display = 'none';
      });
      
      // Process up to 3 files
      files.forEach((file, index) => {
        const reader = new FileReader();
        
        reader.onload = function(e) {
          // Create preview item
          const previewItem = document.createElement('div');
          previewItem.className = 'preview-item';
          previewItem.dataset.index = index;
          previewItem.dataset.filename = file.name;
          
          // Create image preview
          const img = document.createElement('img');
          img.src = e.target.result;
          img.className = 'preview-image';
          img.width = 100;
          img.height = 100;
          img.alt = `Preview ${index + 1}`;
          previewItem.appendChild(img);
          
          // Create filename display
          const fileNameEl = document.createElement('span');
          fileNameEl.className = 'preview-filename';
          fileNameEl.textContent = file.name;
          previewItem.appendChild(fileNameEl);
          
          // Create remove button
          const removeBtn = document.createElement('button');
          removeBtn.className = 'remove-single-image';
          removeBtn.innerHTML = '×';
          removeBtn.setAttribute('aria-label', `Remove ${file.name}`);
          removeBtn.dataset.index = index;
          removeBtn.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Remove this preview item
            previewItem.remove();
            
            // Update the files in the input (if browser supports DataTransfer)
            if (window.DataTransfer) {
              try {
                const dataTransfer = new DataTransfer();
                Array.from(input.files)
                  .filter((f, i) => i !== parseInt(this.dataset.index))
                  .forEach(file => dataTransfer.items.add(file));
                
                input.files = dataTransfer.files;
              } catch (err) {
                console.error('Error updating files:', err);
                // Fallback for browsers that don't fully support DataTransfer
                input.value = '';
                previewContainer.innerHTML = '';
              }
            } else {
              // Fallback for older browsers
              input.value = '';
              previewContainer.innerHTML = '';
            }
            
            // Show instructions if no files remain
            if (previewContainer.children.length === 0 || previewContainer.querySelectorAll('.preview-item').length === 0) {
              wrapper.querySelectorAll('.upload-main-instruction, .upload-sub-instruction, .file-icon').forEach(el => {
                el.style.display = 'block';
              });
              
              // Clear the clear all button container
              clearAllContainer.innerHTML = '';
            }
            
            // Update clear all button visibility
            updateClearAllButton();
          };
          previewItem.appendChild(removeBtn);
          
          // Add to container
          previewContainer.appendChild(previewItem);
          
          // Update clear all button after adding a new preview
          updateClearAllButton();
        };
        
        reader.readAsDataURL(file);
      });
      
      // Function to update the clear all button visibility
      function updateClearAllButton() {
        // Clear the container first
        clearAllContainer.innerHTML = '';
        
        // Only add the button if there are multiple files
        if (previewContainer.querySelectorAll('.preview-item').length > 1) {
          const clearAllBtn = document.createElement('button');
          clearAllBtn.className = 'clear-all-images';
          clearAllBtn.textContent = 'Clear All';
          clearAllBtn.setAttribute('aria-label', 'Clear all images');
          clearAllBtn.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Clear all previews
            previewContainer.innerHTML = '';
            clearAllContainer.innerHTML = '';
            
            // Reset input
            input.value = '';
            
            // Show instructions
            wrapper.querySelectorAll('.upload-main-instruction, .upload-sub-instruction, .file-icon').forEach(el => {
              el.style.display = 'block';
            });
          };
          clearAllContainer.appendChild(clearAllBtn);
        }
      }
    });
    
    // Make the wrapper clickable but avoid triggering when clicking on preview items or buttons
    wrapper.addEventListener('click', function(e) {
      // Only trigger file select dialog when clicking on the wrapper itself or instructions
      if (e.target === wrapper || 
          e.target.classList.contains('file-icon') || 
          e.target.classList.contains('upload-main-instruction') || 
          e.target.classList.contains('upload-sub-instruction')) {
        input.click();
      }
    });
  }

  // Setup image upload handlers
  setupImageUpload('idea_tell_us_file_1');
  setupImageUpload('idea_tell_us_file');
  setupImageUpload('find_crest_name_file');
  //setupImageUpload('band_style_file');
  
  // Initialize dynamic metal options
  // Dynamic Metal Event Listeners for tab-3b
  const metalElements = document.querySelectorAll('.a-metal');
  metalElements.forEach(function(element) {
    const id = element.id;
    if (id && id.startsWith('metal-')) {
      const number = id.replace('metal-', '');
      // const paragraphs = element.querySelectorAll('p');
      // const metalName = paragraphs.length > 0 ? paragraphs[0].textContent : '';
      const metalName = element.dataset.metalName;
      element.addEventListener("click", function (e) {
        tabs.setMetal(metalName, number);
      });
    }
  });
};
